import React from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";
import { Wrapper } from './styles';

const override = css`
  size:26px;
`;

const Loading:React.FC = () =>{
    return(
        <Wrapper>
            <ClipLoader css={override} color={'#fff'}/>
        </Wrapper>
    )
}

export default Loading;